import React, { Component } from 'react';

import Numbers from './components/Numbers';
import Letters from './components/Letters';
import Letters2 from './components/Letters2';
import Letters3 from './components/Letters3';
import LettersLat from './components/LettersLat';
import NumbersAndLetters from './components/NumbersAndLetters';
import Country from './components/Country';
import Gender from './components/Gender';
import Boolean from './components/Boolean';
import CategoryCar from './components/CategoryCar';
import InfoAbout from './components/InfoAbout';
import NumbersMoney from './components/NumbersMoney';
import NumbersAndLettersLat from './components/NumbersAndLettersLat'

var Keyboard = React.createClass({
  getInitialState: function(){
    return {
      type: this.props.type
    }
  },
  componentWillReceiveProps: function(nextProps) {
		if (this.state.type != nextProps.type) {
			this.setState({
				type: nextProps.type
		  });
		}
	},
  render: function(){
    var type = this.state.type;

    if(type == 'numbers'){
      return(
        <Numbers
          actionSaveField={this.props.actionSaveField}
          defaultText={this.props.defaultText}
          actionDoneNext={this.props.actionDoneNext}
          regexp={this.props.regexp}
          text={this.props.text}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
        />
      );
    }else if(type == 'letters'){
      return(
        <Letters
          actionSaveField={this.props.actionSaveField}
          defaultText={this.props.defaultText}
          actionDoneNext={this.props.actionDoneNext}
          regexp={this.props.regexp}
          autoNext={this.props.autoNext}
          text={this.props.text}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
        />
      );
    }else if(type == 'letters2'){
      return(
        <Letters2
          actionSaveField={this.props.actionSaveField}
          defaultText={this.props.defaultText}
          actionDoneNext={this.props.actionDoneNext}
          regexp={this.props.regexp}
          autoNext={this.props.autoNext}
          text={this.props.text}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
        />
      );
    }else if(type == 'letters3'){
      return(
        <Letters3
          actionSaveField={this.props.actionSaveField}
          defaultText={this.props.defaultText}
          actionDoneNext={this.props.actionDoneNext}
          regexp={this.props.regexp}
          autoNext={this.props.autoNext}
          text={this.props.text}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
          closeKeyboard={this.props.closeKeyboard}
        />
      );
    }else if(type == 'lettersLat'){
      return(
        <LettersLat
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          text={this.props.text}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
        />
      );
    }else if(type == 'numbersAndLetters'){
      return(
        <NumbersAndLetters
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
        />
      );
    }else if(type == 'coutry'){
      return(
        <Country
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
        />
      );
    }else if(type == 'gender'){
      return(
        <Gender
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
        />
      );
    }else if(type == 'boolean'){
      return(
        <Boolean
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
        />
      );
    }else if(type == 'categoryCar'){
      return(
        <CategoryCar
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
        />
      );
    }else if(type == 'infoAbout'){
      return(
        <InfoAbout
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
          advertisingSites={this.props.advertisingSites}
        />
      );
    }else if(type == 'numbersMoney'){
      return(
        <NumbersMoney
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
        />
      );
    }else if(type == 'NumbersAndLettersLat'){
      return(
        <NumbersAndLettersLat
          actionSaveField={this.props.actionSaveField}
          actionDoneNext={this.props.actionDoneNext}
          text={this.props.text}
          regexp={this.props.regexp}
          defaultText={this.props.defaultText}
          autoNext={this.props.autoNext}
          mobile={this.props.mobile}
          opperativeKey={this.props.opperativeKey}
        />
      );
    }else{
      return(
        <div>Клавиатура не найдена</div>
      );
    }
  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/index.jsx
 **/